import React from "react";

export const CAMBRIDGE_LOGO_URL = "/images/cambridge-logo.png";
export const CAMBRIDGE_LOGO_URL_LIGHT = "/images/cambridge-logo-light.png";

export default function CambridgeLogo({
  className = "",
  height = 56,
  variant = "dark",
  testid,
}) {
  const src = variant === "light" ? CAMBRIDGE_LOGO_URL_LIGHT : CAMBRIDGE_LOGO_URL;
  return (
    <span className={`inline-flex items-center ${className}`} data-testid={testid}>
      <img
        decoding="async"
        loading="lazy"
        src={src}
        alt="Cambridge Early Years Centre"
        style={{ height, width: "auto" }}
        className="block"
      />
    </span>
  );
}
